import React from 'react';
import { useNavigate } from 'react-router-dom';

const Link = ({ to, name, onClick, className = '' }) => {
  const navigate = useNavigate();

  const handleClick = (e) => {
    navigate(to);
    if (onClick) onClick(e);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleClick(e);
    }
  };

  return (
    <span
      role="link"
      tabIndex={0}
      className={`navLinkText ${className}`}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
    >
      {name}
    </span>
  );
};

export default Link;